function normalizeTrendUiText(value: unknown): string {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (Array.isArray(value)) {
    return value
      .map((entry) => normalizeTrendUiText(entry))
      .filter(Boolean)
      .join('; ')
      .trim();
  }
  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    const nested = [
      normalizeTrendUiText(record.message),
      normalizeTrendUiText(record.error),
      normalizeTrendUiText(record.reason),
      normalizeTrendUiText(record.detail),
      normalizeTrendUiText(record.code),
      normalizeTrendUiText(record.type),
    ].filter(Boolean);
    if (nested.length > 0) {
      return nested.join(' - ').trim();
    }
    try {
      return JSON.stringify(value);
    } catch {
      return '';
    }
  }
  return '';
}

export function coerceTrendUiText(value: unknown): string {
  return normalizeTrendUiText(value);
}

export function extractTrendUiErrorMessage(error: any, fallback: string): string {
  const candidates = [
    error?.response?.data?.error,
    error?.response?.data?.message,
    error?.response?.data?.details,
    error?.error,
    error?.message,
  ];

  for (const candidate of candidates) {
    const normalized = normalizeTrendUiText(candidate);
    if (normalized) return normalized;
  }

  return fallback;
}
